var map = {
	"./aave-logo.png": 3259,
	"./ada-logo.png": 5378,
	"./algo-logo.png": 2435,
	"./apt-logo.png": 4041,
	"./ar-logo.png": 7363,
	"./atom-logo.png": 5833,
	"./audusd-logo.png": 8606,
	"./avax-logo.png": 9406,
	"./bch-logo.png": 7119,
	"./bnb-logo.png": 2052,
	"./btc-logo.png": 537,
	"./cadusd-logo.png": 316,
	"./chfusd-logo.png": 3825,
	"./cl-logo.png": 5099,
	"./doge-logo.png": 3777,
	"./dot-logo.png": 3125,
	"./eos-logo.png": 9475,
	"./es-logo.png": 3960,
	"./etc-logo.png": 376,
	"./eth-logo.png": 2229,
	"./eurusd-logo.png": 9116,
	"./fet-logo.png": 4741,
	"./fil-logo.png": 3633,
	"./ftm-logo.png": 7019,
	"./gbpusd-logo.png": 3069,
	"./gc-logo.png": 6234,
	"./grt-logo.png": 1825,
	"./imx-logo.png": 7960,
	"./inj-logo.png": 3861,
	"./jpyusd-logo.png": 7791,
	"./ldo-logo.png": 659,
	"./link-logo.png": 1500,
	"./ltc-logo.png": 4287,
	"./matic-logo.png": 1080,
	"./mkr-logo.png": 8024,
	"./near-logo.png": 5874,
	"./op-logo.png": 6787,
	"./pl-logo.png": 452,
	"./render-logo.png": 3708,
	"./rune-logo.png": 2616,
	"./si-logo.png": 1904,
	"./sol-logo.png": 4568,
	"./stx-logo.png": 6099,
	"./sui-logo.png": 9209,
	"./tao-logo.png": 2022,
	"./theta-logo.png": 6034,
	"./ton-logo.png": 9687,
	"./trx-logo.png": 5532,
	"./uni-logo.png": 3932,
	"./usdt.png": 1958,
	"./vet-logo.png": 5461,
	"./wbtc-logo.png": 928,
	"./wif-logo.png": 4592,
	"./xlm-logo.png": 2197,
	"./xrp-logo.png": 5552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9793;